import useFetch from '../hooks/useFetch';
import usePlaceholder from '../hooks/usePlaceholder';
import Placeholder from './Placeholder';
import Service from './Service';

const HomeServices = () => {
    const [services] = useFetch();
    const [placeholder] = usePlaceholder();

    
    return (
        <section className="relative top-10">
            <h1 className="transition transform duration-300 ease-in-out text-center text-4xl text-indigo-700 font-semibold font_poppins hover:scale-105">Services</h1>

        {/* services  */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 my-12">
                {services.slice(0,4).map((item) => (
                    placeholder ? <Placeholder key={Math.random()}/> :
                    <Service key={Math.random()} {...item} />
                ))}
            </div>

        </section>
    )
}

export default HomeServices
